import { all, fork } from 'redux-saga/effects';
import coreSaga from "./core/saga";

export default function* rootSaga() {
  yield all([
    fork(coreSaga),
  ]);
}
